// extracted by mini-css-extract-plugin
export default {"dimension":"FZVTS","parameter":"sE7Ro","select":"TDVs5","selects":"_PYWF","dimensions":"IDL4a","hardness":"zEHiN"};